import { inject } from '@angular/core';
import { Router, UrlTree } from '@angular/router';
import { CurrentSubscriptionService } from '@rma/billing/subscription-plans/public/api-subscription-features';
import { map, Observable, take } from 'rxjs';

export function checkIsSubscribed(): Observable<true | UrlTree> {
  const router = inject(Router);
  const subscriptionService = inject(CurrentSubscriptionService);

  return subscriptionService.currentSubscription$.pipe(
    take(1),
    map((subscription) => subscription.isSubscribed || router.createUrlTree(['/manage-account/billing'])),
  );
}
